<section class="mt-[80px] grid grid-cols-9 gap-2 animate-fade-in">
  <app-key *ngFor="let letter of buttonLetters" [GetLetter]="letter" />
</section>